module.exports = __webpack_public_path__ + "static/img_9553-87f1d0b8127b5ba6f97474fcdf56a6e1.webp";